module.exports = {
  "menu.btn.profile": "������",
  "menu.btn.shop": "����",
  "menu.btn.social": "�Ҽ�",
  "menu.btn.maps": "��",
  "menu.btn.mods": "����",
  "menu.btn.settings": "����",
  "menu.btn.customize": "Ŀ���͸�����",
  "menu.btn.invite": "�ʴ��ϱ�",
  "menu.btn.invite.clicked": "���� �Ϸ�",
  "menu.btn.join": "�����ϱ�",
  "menu.btn.host": "�� ������",
  "menu.btn.browser": "���� ��������",
  "generic.wait": "���ø� ���ٷ� �ּ���...",
  "generic.loading": "�ҷ����� ��...",
  "generic.connecting": "���� ��...",
  "generic.none": "����",
  "generic.select": "����",
  "generic.delete": "����",
  "generic.save": "����",
  "generic.load": "�ҷ�����",
  "generic.search": "�˻�",
  "generic.leave": "������",
  "generic.default": "�⺻��",
  "generic.submit": "����",
  "generic.create": "������",
  "generic.failed": "����",
  "generic.success": "����!",
  "generic.name": "�̸�",
  "generic.level": "����",
  "generic.score": "����",
  "generic.off": "����",
  "generic.score": "����",
  "generic.victory": "�¸�",
  "generic.defeat": "�й�",
  "generic.follow": "�ȷο�",
  "generic.unfollow": "�ȷο� ����",
  "generic.followers": "�ȷο�",
  "generic.following": "�ȷ���",
  "generic.games": "����",
  "generic.wins": "�¸�",
  "generic.clan": "Ŭ��",
  "generic.kills": "óġ",
  "generic.deaths": "����",
  "generic.kdr": "KDR",
  "generic.games.played": "ġ�� ����",
  "generic.games.won": "�¸��� ����",
  "generic.timep": "�÷����� �ð�",
  "generic.time": "�ð�",
  "generic.logout": "�α׾ƿ�",
  "generic.logout.sessions": "���� ���ǿ��� �α׾ƿ�",
  "generic.username": "�����ڸ� �Է�",
  "generic.password": "���й�ȣ �Է�",
  "generic.register": "����",
  "generic.login": "�α���",
  "generic.accuracy": "��Ȯ��",
  "player.waiting": "�÷��̾ ���ٸ��� ��",
  "player.died": "You died",
  "player.killed": "���� ����",
  "player.killstreak": "{0}��(��) {1} ���� óġ",
  "player.inactive": "Ȱ������ �ʾ� �����߽��ϴ�.",
  "player.disconnect": "���� ����",
  "timer.end": "���� ������ ���۱��� {0}",
  "leaderboard.empty": "�� �κ�",
  "popup.checkpoint": "üũ����Ʈ!",
  "app.play": "���� �����ϱ�",
  "app.play.controller": "���� ��ư�� ��������.",
  "purchase.error": "������ �߻��߽��ϴ�.",
  "purchase.error.click": "����</a>�� Ŭ���� �ٽ� �õ��� ������!",
  "purchase.error.limit": "���� �ŷ� �ѵ��� �ʰ����� �� �ֽ��ϴ�.",
  "settings.reset": "���� �ʱ�ȭ",
  "settings.reset.confirm": "���� ������ �ʱ�ȭ�Ͻðڽ��ϱ�? ���� �������� ���� ��ħ �մϴ�.",
  "settings.controls.change": "���� ����",
  "settings.controls.press": "�ƹ� Ű�� ���� �ּ���.",
  "settings.server.header": "����",
  "settings.server.region": "�⺻ ����",
  "settings.quality.header": "ǰ��",
  "settings.quality.res": "�ػ���",
  "settings.quality.part": "���� ȿ��",
  "settings.quality.trails": "�Ѿ� ����",
  "settings.quality.mflash": "�ѱ� ����",
  "settings.interface.header": "�������̽�",
  "settings.interface.ui": "UI ���̱�",
  "settings.interface.hp": "���̳��� HP ��",
  "settings.interface.chat": "ä��â ���̱�",
  "settings.interface.kills": "����â ���̱�",
  "settings.interface.messages": "�÷��̾� �޽��� ���̱�",
  "settings.interface.unboxings": "������ ���� ���̱�",
  "settings.interface.ping": "�� ���̱�",
  "settings.interface.fps": "FPS ���̱�",
  "settings.interface.deaths": "���� ���̱�",
  "settings.crosshair.header": "������",
  "settings.crosshair.type": "Ÿ��",
  "settings.crosshair.type.2": "Ŀ����",
  "settings.crosshair.type.3": "���̾���",
  "settings.crosshair.type.4": "�̹���",
  "settings.crosshair.style": "��Ÿ��",
  "settings.crosshair.style.0": "������ ����",
  "settings.crosshair.style.1": "������ ����",
  "settings.crosshair.style.2": "�������� ����",
  "settings.crosshair.style.3": "������ �簢��",
  "settings.crosshair.style.4": "�������� �簢��",
  "settings.crosshair.image": "�̹���",
  "settings.crosshair.image.paste": "������ �̹���",
  "settings.crosshair.always": "�׻� ���̱�",
  "settings.crosshair.color": "����",
  "settings.crosshair.shadow": "�׸���",
  "settings.crosshair.size": "ũ��",
  "settings.crosshair.thickness": "����",
  "settings.onKillS.style.0": "�⺻��",
  "settings.onKillS.style.1": "�ػ��� ����",
  "settings.onKillS.style.2": "FOV ����",
  "settings.onKillS.style.3": "FOV Ȯ��",
  "settings.gameplay.header": "�����÷���",
  "settings.gameplay.sensitivity": "�ΰ���",
  "settings.gameplay.aimsens": "���� �ΰ���",
  "settings.gameplay.fov": "�þ߰�",
  "settings.gameplay.fps": "���� FOV",
  "settings.gameplay.streamer": "��Ʈ���� ����",
  "settings.gameplay.challenge": "ç���� ����",
  "settings.gameplay.invert": "Y�� ����",
  "settings.gameplay.onkillS": "óġ ��",
  "settings.audio.header": "������",
  "settings.audio.sound": "������",
  "settings.audio.voice": "���� ����",
  "settings.editing.header": "������",
  "settings.editing.weapon": "���� ���̱�",
  "settings.editing.bobbing": "���� ���鸲",
  "settings.editing.depth": "���� ��",
  "settings.editing.green": "�׸� ��ũ��",
  "settings.shaders.header": "���̴�",
  "settings.shaders.ambient": "�ں���Ʈ ���̵�",
  "settings.mods.header": "����",
  "settings.mods.load": "���� �ҷ�����",
  "settings.mods.auto": "���� �ڵ� �ҷ�����",
  "settings.mods.borders": "���ذ� ȭ�� ����",
  "settings.mods.scope": "���ذ� �̹���",
  "settings.mods.scope.paste": "���ذ� �̹��� URL",
  "settings.mods.dot": "���� ��Ʈ �̹���",
  "settings.mods.dot.paste": "���� ��Ʈ URL",
  "settings.mods.endmessage": "��ġ ���� �޽���",
  "settings.mods.profile": "������ �̹���",
  "settings.mods.profile.paste": "������ �̹��� URL",
  "windows.settings.header": "���� ����",
  "windows.servers.header": "���� ��������",
  "windows.servers.none": "������ �� �ִ� ������ �����ϴ�...",
  "windows.servers.host": "+ �� ������",
  "windows.servers.hide": "Ǯ�� ������",
  "windows.servers.online": "�� {0}�� �¶���",
  "windows.loadout.header": "�ε��ƿ� ����",
  "windows.loadout.class": "Ŭ����",
  "windows.loadout.primary": "�� ����",
  "windows.loadout.secondary": "���� ����",
  "windows.loadout.melee": "����",
  "windows.loadout.hat": "����",
  "windows.loadout.body": "����",
  "windows.loadout.spray": "��������",
  "windows.mods.header": "���� �Ŵ���",
  "windows.mods.guide": "���� ���̵�",
  "windows.mods.list": "���� ����",
  "windows.mods.publish": "���� ���ε�",
  "windows.mods.viewer": "����",
  "windows.mods.drop": "���� ������ ���⿡ �����ϰų� Ŭ���ϼ���.",
  "windows.mods.paste": "���� URL ���̱�",
  "windows.mods.load": "���� �ҷ�����",
  "windows.account.header": "����",
  "windows.account.recover": "���� ���� ��û�� <a>krunker@yendis.ch</a>�� ���� �ּ���.",
  "windows.class.header": "Ŭ���� ����",
  "windows.controls.header": "���� ����",
  "windows.controls.forward": "������",
  "windows.controls.backward": "�ڷ�",
  "windows.controls.left": "��������",
  "windows.controls.right": "����������",
  "windows.controls.reload": "������",
  "windows.controls.aim": "����",
  "windows.controls.inspect": "����",
  "windows.controls.spray": "��������",
  "windows.controls.jump": "����",
  "windows.controls.crouch": "��ũ����",
  "windows.controls.next": "���� ����",
  "windows.controls.previous": "���� ����",
  "windows.controls.chat": "ä��",
  "windows.controls.voice": "����",
  "windows.controls.list": "�÷��̾� ����",
  "windows.controls.interact": "��ȣ �ۿ�",
  "windows.controls.drop": "������",
  "windows.host.header": "Ŀ���� �� ������",
  "windows.host.maps": "�� ����",
  "windows.host.cmaps": "Ŀ�´�Ƽ ��",
  "windows.host.raw": "�̰��� �� ������",
  "windows.host.modes": "���� ����",
  "windows.host.classes": "Ŭ���� ����",
  "windows.host.settings": "���� ����",
  "windows.host.preset": "���� ���� �����ϱ�",
  "windows.host.preset.load": "���� ������ �ҷ����� ��...",
  "windows.host.preset.name": "���� ���� �̸�",
  "windows.host.start": "���� ����",
  "windows.spray.header": "�������� ����",
  "windows.spray.default": "�⺻ ��������",
  "windows.maps.header": "Ŀ���� ��",
  "windows.maps.none": "������ ã�� �� �����ϴ�!",
  "windows.maps.name": "�� �̸�",
  "windows.maps.editor": "�� ������",
  "windows.maps.publish": "�� ���ε�",
  "windows.maps.community": "�� Ŀ�´�Ƽ",
  "windows.publish.map.header": "�� ���ε�",
  "windows.publish.map.thumbnail": "������ ����",
  "windows.publish.map.paste": "�� ������ ���̱�",
  "windows.publish.map.update": "���ε�/������Ʈ",
  "windows.publish.map.login": "���� �����ų� ���ε��Ϸ��� �α����ϼ���.",
  "windows.theatre.header": "���� ����",
  "windows.theatre.record": "��ȭ Ȱ��ȭ",
  "windows.theatre.key": "Record Key",
  "windows.clans.header": "Ŭ��",
  "windows.clans.members": "���� �� ({0})",
  "windows.clans.requests": "��û",
  "windows.clans.requests.none": "��û ����",
  "windows.clans.page": "[{0}] Ŭ�� ������",
  "windows.clans.create": "Ŭ�� ������",
  "windows.clans.name": "Ŭ�� �̸�",
  "windows.clans.view": "Ŭ�� ����",
  "windows.clans.join": "Ŭ�� ����",
  "windows.clans.login": "Ŭ���� �����ų� �����Ϸ��� �α����ϼ���!",
  "windows.store.header": "����",
  "windows.store.spin": "{0} ����",
  "windows.store.agree": "���� �� {0}������ �����ϴ� ������ ���ֵ˴ϴ�.",
  "windows.store.purchase": "KR ����",
  "windows.store.market": "�����÷��̽�",
  "windows.store.market2": "Krunker ����",
  "windows.store.buy": "���� �������� �Ÿ��ϼ���.",
  "windows.store.wheels": "������ �귿",
  "windows.store.unlock": "���ο� ���� ��Ų�� �������� �Լ��ϼ���.",
  "windows.store.amount": "{0} KR ���� ��",
  "windows.store.login": "�������� �������� ����, �Լ��Ϸ��� �α����ϼ���!",
  "windows.store.purchasing": "���� ��...",
  "windows.skin.header": "��Ų ����",
  "windows.hat.header": "���� ����",
  "windows.back.header": "�ĸ� ����",
  "windows.mods.community.header": "Ŀ�´�Ƽ ����",
  "windows.mods.community.fav": "�� ����ã��",
  "windows.mods.community.new": "�� ����",
  "windows.mods.community.hot": "�α�",
  "windows.mods.community.name": "���� �̸�",
  "windows.mods.community.none": "���带 ã�� �� �����ϴ�!",
  "windows.publish.mod.header": "���� ���ε�",
  "windows.publish.mod.thumbnail": "������ ����",
  "windows.publish.mod.name": "���� �̸�",
  "windows.publish.mod.paste": "���� URL",
  "windows.publish.mod.update": "���ε�/������Ʈ",
  "windows.publish.mod.login": "���带 �����ų� ������Ʈ�Ϸ��� �α����ϼ���!",
  "windows.secondary.header": "���� ��ǥ ����",
  "windows.secondary.unlocked": "{0}�������� ����",
  "windows.secondary.req": "{0}���� �ʼ�",
  "windows.advertise.header": "����",
  "windows.players.header": "�÷��̾� ����",
  "windows.players.none": "�÷��̾ �����ϴ�...",
  "windows.join.header": "�����ϱ�",
  "windows.join.code": "���� URL/�ڵ� �Է�",
  "windows.client.header": "Ŭ���̾�Ʈ",
  "windows.client.windows": "���� ��ġ ����",
  "windows.client.mac": "��OS ��ġ ����",
  "windows.client.linux": "������ ��ġ ����",
  "thumbnail.upload.limit": "����. �������� 40kb ���� ũ�⸸ �����˴ϴ�.",
  "thumbnail.upload.error": "������ ����",
  "mod.extracting": "{0}/{1} ���� ��",
  "mod.disabled": "���� ��Ȱ��ȭ",
  "mod.error": "���� ����!",
  "mod.loading": "���带 �ҷ����� ��...",
  "mod.invalid": "��ȿ���� ���� ���� ����!",
  "matchmaker.full": "�ο��� �� á���ϴ�.",
  "matchmaker.full2": "������ �� á���ϴ�.",
  "matchmaker.none": "������ ã�� �� �����ϴ�.",
  adblocker: "���� Krunkies�� �������� ���� ������ ��Ȱ��ȭ�� �ּ���.",
  "streamers.views": "{0}�� ��û ��",
  "streamers.none": "���� ���� ��Ʈ���� �����ϴ�!",
  "error.extentions": "�ͽ��ټ��� �ִٸ� ��Ȱ��ȭ�� �ּ���.",
  "error.seek": "���⸦ Ŭ���ؼ� �� ������ ã�ƺ�����.",
  "custom.map.missing": "���� �ּ� �� ���� ������ �ּ���.",
  "custom.mode.missing": "���带 �ּ� �� ���� ������ �ּ���.",
  "custom.class.missing": "Ŭ������ �ּ� �� ���� ������ �ּ���.",
  "server.config.maxPlayers": "�÷��̾� ��",
  "server.config.minPlayers": "�ּ� �÷��̾� ��",
  "server.config.lives": "����",
  "server.config.gameTime": "�ð�(��)",
  "server.config.gravMlt": "�߷�",
  "server.config.jumpMlt": "������",
  "server.config.deltaMlt": "Ÿ�� ������",
  "server.config.strafeSpd": "��Ʈ������ �ӵ�",
  "server.config.healthMlt": "ü�� �¼�",
  "server.config.impulseMlt": "���� ���ݷ�",
  "server.config.nameTeam1": "1�� �̸�",
  "server.config.nameTeam2": "2�� �̸�",
  "server.config.selTeam": "�� ����",
  "server.config.allowSpect": "���� ��",
  "server.config.killRewards": "óġ ����",
  "server.config.canSlide": "�����̵�",
  "server.config.autoJump": "�ڵ� ����",
  "server.config.thirdPerson": "3��Ī ����",
  "server.config.nameTags": "�̸�ǥ ������",
  "server.config.private": "���й�",
  "social.login": "�α���/����",
  "social.login.failed": "�α��� ����",
  "social.login.buy": "�α����ؼ� �����ϱ�",
  "social.login.sell": "�α����ؼ� �Ǹ��ϱ�",
  "social.login.proccessing": "�α��� ��...",
  "social.since": "������",
  "social.user.maps": "������ ��",
  "social.user.mods": "������ ����",
  "social.maps.none": "���� ã�� �� �����ϴ�...",
  "social.market.head": "�Ӹ� ������",
  "social.market.back": "�ĸ� ������",
  "social.market.none": "�������� ã�� �� �����ϴ�.",
  "social.market.grace": "{0} �� ���� ����",
  "social.market.sort": "����/����",
  "social.market.filter": "�˻�",
  "social.market.price.high": "�ְ� ���ݼ�",
  "social.market.price.low": "���� ���ݼ�",
  "social.market.price.list": "���� �Է�",
  "social.market.searching": "�˻� ��",
  "social.market.listed": "{0} ���� ������",
  "social.market.list": "������ ����",
  "social.market.unlist": "���� ����",
  "social.market.unlisting": "������ ���� ���� ��...",
  "social.market.posting": "������ ���� ��...",
  "social.market.req": "{0}���� �ʼ�",
  "social.market.cant": "�ڱ� ����",
  "social.market.purchase": "����",
  "social.market.fee": "���� ������ ����",
  "social.market.failed": "����. �ٽ� �õ��ϼ���."
};